export const getStat = (stats: any[], metric: any) =>
  stats?.find((node: any) => node?.metric === metric);
